import { Route, Switch, Redirect } from "react-router-dom";
import HippoAdminLayout from "./layouts/HipposAdmin.js";
import { apiService } from "./service/ApiService";
import HippoAuthLayout from "./layouts/HipposAuth.js";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import StoreContext from "./contexts/StoreContext";
import DateRangeContext from "./contexts/DateRangeContext.js";
import UserCreditsContext from "contexts/UserCreditsContext.js";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "flag-icons/css/flag-icons.min.css";
import "assets/scss/light-bootstrap-dashboard-pro-react.scss?v=2.0.0";
import "assets/css/demo.css";
import "assets/css/custom.css";
import "react-calendar/dist/Calendar.css";
import { useState } from "react";

function App() {
  const [refreshCredits, setRefreshCredits] = useState(true);
  const [storeId, setStoreId] = useState(null);
  const [dateRange, setDateRange] = useState(null);
  const creditsValue = { refreshCredits, setRefreshCredits };
  const storeValue = { storeId, setStoreId };
  const dateRangeValue = { dateRange, setDateRange };

  return (
    <Switch>
      <Route path="/auth" render={(props) => <HippoAuthLayout {...props} />} />
      <UserCreditsContext.Provider value={creditsValue}>
        <DateRangeContext.Provider value={dateRangeValue}>
          <StoreContext.Provider value={storeValue}>
            <ProtectedRoute path="/admin" component={HippoAdminLayout} />
          </StoreContext.Provider>
        </DateRangeContext.Provider>
      </UserCreditsContext.Provider>
      <Redirect from="/" to={apiService.isTokenOk() ? "/admin/dashboard" : "auth/login-page"} />
    </Switch>
  );
}

export default App;
